export default __webpack_public_path__ + "locales/ru/BackupCodesDialog.json?hash=f20ad7af2753fab1f49bca4964c9162d";